/**
 * Password field utilities — Alpine.js components
 * - passwordToggle: show/hide password visibility
 * - passwordStrength: real-time strength meter for registration
 */
document.addEventListener('alpine:init', function () {

  /* ── Show/hide toggle for any password field ── */
  Alpine.data('passwordToggle', function () {
    return {
      show: false,
      toggle: function () {
        this.show = !this.show;
      }
    };
  });

  /* ── Password strength meter with toggle (registration only) ── */
  Alpine.data('passwordStrength', function () {
    return {
      password: '',
      show: false,
      toggle: function () {
        this.show = !this.show;
      },
      get score() {
        var pw = this.password;
        if (!pw) return 0;
        // B2B: passwords under 8 chars always score weak
        if (pw.length < 8) return 0;
        var s = 0;
        if (pw.length >= 8) s++;
        if (pw.length >= 12) s++;
        if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
        if (/\d/.test(pw)) s++;
        if (/[^a-zA-Z0-9]/.test(pw)) s++;
        // 0-1 = weak, 2-3 = medium, 4-5 = strong
        return s;
      },
      get level() {
        if (!this.password) return '';
        if (this.score <= 1) return 'weak';
        if (this.score <= 3) return 'medium';
        // B2B strong: 12+ chars AND mixed case AND (digit OR special)
        var pw = this.password;
        if (pw.length >= 12 && /[a-z]/.test(pw) && /[A-Z]/.test(pw) && (/\d/.test(pw) || /[^a-zA-Z0-9]/.test(pw))) return 'strong';
        return 'medium';
      },
      get label() {
        if (!this.password) return '';
        if (this.score <= 1) return 'Weak';
        if (this.score <= 3) return 'Medium';
        var pw = this.password;
        if (pw.length >= 12 && /[a-z]/.test(pw) && /[A-Z]/.test(pw) && (/\d/.test(pw) || /[^a-zA-Z0-9]/.test(pw))) return 'Strong';
        return 'Medium';
      },
      get percent() {
        if (!this.password) return 0;
        if (this.score <= 1) return 33;
        if (this.level === 'strong') return 100;
        return 66;
      }
    };
  });
});
